export const PORTAL_SERVICOS_BACKEND =
    process.env.REACT_APP_PORTAL_SERVICOS_BACKEND;

export const PORTAL_SERVICOS_OAUTH =
    process.env.REACT_APP_PORTAL_SERVICOS_OAUTH;
